import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { CookieModule } from 'ngx-cookie';
import { THREATMETRIX_CONFIG } from './threatmetrix.config';
import type { ThreatmetrixConfig } from './threatmetrix.interface';
import { ThreatmetrixService } from './threatmetrix.service';

@NgModule({
  imports: [CommonModule, CookieModule.withOptions()],
  providers: [ThreatmetrixService, provideHttpClient(withInterceptorsFromDi())],
})
export class ThreatmetrixModule {
  static initialize(
    config?: ThreatmetrixConfig,
  ): ModuleWithProviders<ThreatmetrixModule> {
    return {
      ngModule: ThreatmetrixModule,
      providers: [{ provide: THREATMETRIX_CONFIG, useValue: config }],
    };
  }
}
